import { Grid } from '@material-ui/core'
import React from 'react'
import News from '../components/main/home/news/News'

function InformationsActualitesScreen() {
  return (
    <Grid container>
      <News />
    </Grid>
  )
}

export default InformationsActualitesScreen
